import React, {Component, Fragment} from 'react';

import './CreditoProcea.css';
import logo_svg from '../../../assets/img/logo.svg';
import logo_procea from '../../../assets/img/icons/procea.png';
import icon_bien from '../../../assets/img/icons/procea_bien.png';
import icon_pregunta from '../../../assets/img/icons/procea_pregunta.png';

import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../settings/IntegrationNotistack/IntegrationNotistack";
import {ReactLocalStorageService} from "../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import {FieldsJs} from "../../../settings/General/General";
import Icon from '@material-ui/core/Icon';
import Chart from "react-google-charts";
import Typography from "@material-ui/core/Typography";
import {HomeService} from "../../../services/HomeService/HomeService";
import {CONFIG} from "../../../settings/Config/Config";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import BarraProgreso from "../Tickets/Includes/BarraProgreso";
import VistaVacia from "../../Include/VistaVacia/VistaVacia";
import {CatService} from "../../../services/_Cat/CatService/CatService";
import {VacacionesService} from "../../../services/VacacionesService/VacacionesService";
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

// import Button from "@material-ui/core/Button";


const ItemGraficaArea = ({state}) => {
	let grafica = [
		['Progreso de ventas', 'Porcentaje']
	];
	grafica.push([state.venta_creado_disenador_asignado_texto, state.venta_creado_disenador_asignado.length]);
	
	return (
		<Fragment>
			<div align={'center'} style={{width: '100%'}} className={'margin-5 fill-transparent'}>
				
				<Typography component={'h2'} className={'ff-arial'} style={{}}>
					Gráfica porcentaje progreso de ventas
				</Typography>
				
				{grafica.length > 0 ? (
					<Chart
						width={'100%'}
						height={'190px'}
						chartType="Sankey   "
						loader={
							<Typography component={'h2'} className={'ff-arial'}>
								Cargando gráficas...
							</Typography>
						}
						data={grafica}
						options={{
							is3D: true,
							backgroundColor: {fill: 'transparent'},
							title: '',
							legend: {
								alignment: 'center',
								position: 'bottom',
								textStyle: {
									color: 'black',
									fontSize: 10,
								},
							},
							pieHole: 0,
							animation: {
								duration: 1000,
								easing: 'out',
								startup: true,
							},
						}}
						rootProps={{'data-testid': '3'}}
					/>
				) : (
					<Fragment>
						<Typography component={'h2'} className={'ff-arial'}>
							Esperando datos...
						</Typography>
					</Fragment>
				)}
			</div>
		</Fragment>
	);
};


const ItemGrafica = ({state}) => {
	let grafica = [
		['Progreso de ventas', 'Porcentaje']
	];
	grafica.push([state.venta_creado_disenador_asignado_texto, state.venta_creado_disenador_asignado.length]);
	const columns = [
		{type: "string", id: "President"},
		{type: "number", id: "Start"},
		{type: "number", id: "End"}
	];
	
	const rows = [
		["VANTIS S DE RL DE CV", 13, 16],
		["VANGUARDIA EN INYECCION DE PLASTICOS DEL BAJIO S DE RL DE CV", 3, 10]
	];
	
	return (
		<Fragment>
			<div align={'center'} style={{width: '100%'}} className={'margin-5 fill-transparent'}>
				
				<Typography component={'h2'} className={'ff-arial'} style={{}}>
					Gráfica porcentaje progreso de ventas
				</Typography>
				
				{grafica.length > 0 ? (
					<Chart
						width={'100%'}
						height={'190px'}
						chartType="Timeline"
						loader={
							<Typography component={'h2'} className={'ff-arial'}>
								Cargando gráficas...
							</Typography>
						}
						data={[columns, ...rows]}
						options={{
							timeline: {colorByRowLabel: true},
							backgroundColor: '#ffd',
						}}
						rootProps={{'data-testid': '3'}}
					/>
				) : (
					<Fragment>
						<Typography component={'h2'} className={'ff-arial'}>
							Esperando datos...
						</Typography>
					</Fragment>
				)}
			</div>
		</Fragment>
	);
};


class CreditoProcea extends Component {
	
	state = {};
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			Usr: (ReactLocalStorageService.get('Usr') || {}),
			
			venta_creado_disenador_asignado_texto: '',
			venta_creado_disenador_asignado: [
				['Element', 'Density', {role: 'style'}, {role: 'annotation'}],
				['Copper', 8.94, '#b87333', 'Cu'],
				['Silver', 10.49, 'silver', 'Ag'],
				['Gold', 19.30, 'gold', 'Au'],
				['Platinum', 21.45, 'color: #e5e4e2', 'Pt']
			],
			venta_en_produccion_texto: '', venta_en_produccion: [],
			venta_en_almacen_texto: '', venta_en_almacen: [],
			
			listar_home: [],
			lista_tickets: [],
			registros: [],
			cfdi: [],
			acceso: [],
			actividades: [],
			plataformas: [],
			vacaciones: [],
		};
		
		this.ListarHome();
		this.ListarPlataformas();
		//this.ListarVacaciones();
	}
	
	ListarVacaciones = () => {
		let params = {
			id_vacaciones: '',
			id_cat_proyecto: '',
			id_cat_proyecto_modulo: '',
			id_cat_cronograma_estatus: '',
			id_cat_tipo_usuario: '',
			usuario_asignado: '',
			fecha_inicio: null,
			fecha_fin: null,
			activo: 1
		};
		let paginacion = {
			total: null,
			page: 1,
			limit: 5,
			rangos: 5
		};
		VacacionesService.Listar(params, paginacion).then((response) => {
			this.setState({
				vacaciones: response.data,
			});
		}).catch((error) => {
			this.setState({vacaciones: []});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	ListarHome = () => {
		HomeService.Listar().then((response) => {
			this.setState({
				listar_home: response.data || [],
				lista_tickets: response.data.lista_tickets || [],
				registros: response.data.registros || [],
				cfdi: response.data.cfdi || [],
				acceso: response.data.acceso || [],
				actividades: response.data.actividades || [],
				vacaciones: response.data.vacaciones || []
			});
		}).catch((error) => {
			this.setState({
				listar_home: [],
				lista_tickets: [],
				registros: [],
				cfdi: [],
				acceso: [],
				actividades: [],
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	ListarPlataformas = () => {
		CatService.ListPlataformas().then((response) => {
			this.setState({
				plataformas: response.data
			});
		}).catch((error) => {
			this.setState({
				plataformas: [],
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	renderSwitchIcon = (icono) => {
		return <Icon className={'px-30 margin-10-R'} style={{color: '#d9e9eb'}}>{icono}</Icon>;
	};
	
	go = (u) => {
		this.props.history.push('/' + u);
	};
	
	redireccion = (url) => {
		if (FieldsJs.Field(url)) {
			window.open(url, '_blank');
		}
	};
	
	getRegistros = (id_menu) => {
		let registros = 0;
		if (this.state.registros.length > 0) {
			for (let i = 0; i < this.state.registros.length; i++) {
				if (Number(id_menu) === Number(this.state.registros[i].id_menu)) {
					registros = this.state.registros[i].total
				}
			}
		}
		return registros;
	};
	
	
	render() {
		let menu = this.state.Usr.menu || [];
		const bg_logo_svg = {
			backgroundImage: `url(${logo_svg})`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'bottom',
			backgroundAttachment: 'fixed',
			backgroundSize: '350px 350px',
			opacity: '1',
		};
		
		return (
			<div className={'w-100'} align={'center'}>
				<div>
					<div className='Home ContaineViewComponet' style={bg_logo_svg}>
						<Grid container spacing={5}>
							<Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
							</Grid>
							<Grid item xs={12} sm={6} md={5} lg={5} xl={5}>
								<img src={logo_procea} height={200}/>
								<h1 className='text-justify'>PROCESO PARA SOLICITAR UN CREDITO</h1>
								
								<ul className='flecha text-justify'>
									<li>Solicita información a nuestro teléfono o al correo: contacto@operadoraprocea.com o rosana.mollinedo@acresco.com</li>
									<li>Llena tu solicitud de crédito.</li>
									<li>Envía o entrega la documentación solicitada.</li>
									<li>El responsable hará la verificación de tu documentación.</li>
									<li>Se revisara tu solicitud y te darán una tabla de amortización de pagos.</li>
									<li>El área de crédito analiza tu información y la pasa a un comité.</li>
									<li>Si tu crédito es autorizado, el área de crédito se contactara
										contigo para citarte para la firma de contrato, pagare y anexos.
									</li>
									<li>Ya que tienen tu contrato, pagaré y anexos firmados tu préstamo será depositado a tu cuenta.</li>
									<li>Ahora ya puedes disponer del dinero.</li>
								</ul>
								<img src={icon_bien} height={200}/>
							</Grid>
							<Grid item xs={12} sm={6} md={5} lg={5} xl={5} className='text-left'>
								<Grid container spacing={5}>
									<Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
										<img src={icon_pregunta} height={200}/>
									</Grid>
									<Grid item xs={12} sm={6} md={10} lg={10} xl={10}>
										<h3 className='text-justify margin-60-T margin-60-B'>REQUISITOS PARA SOLICITAR TU CREDITO</h3>
										<p className='text-justify'>ENTREGA LA SIGUIENTE DOCUMENTACION:</p>
										<ul className='numero text-justify'>
											<li>COPIA IDENTIFICACION OFICIAL VIGENTE</li>
											<li>COPIA DE COMPROBANTE DE DOMICILIO CON ANTIGÜEDAD NO MAYOR A TRES MESES</li>
											<li>COPIA DE ESTADO DE CUENTA BANCARIO</li>
											<li>REPORTE DE BURO DE CREDITO NO IMPORTA TU SCORE</li>
											<li>COPIA DE COMPROBANTE DE INGRESOS</li>
											<li>CURP ACTUALIZADO</li>
											<li>ENTREGA TU SOLICITUD LLENA</li>
											<li>ENTREGA TU FORMATO DE CONOCIMIENTO AL CLIENTE.</li>
										</ul>
										<h2 className='text-justify'>Ahora si ya tienes todo para empezar.............</h2>
										<h2 className='text-justify'>LLAMANOS o CONTACTANOS!!!!</h2>
										<p className='padding-0 margin-2 text-bold'>Teléfono: (442) 199 00 41</p>
										<p className='padding-0 margin-2 text-bold'>Fax: (442) 218 12 89</p>
										<p className='padding-0 margin-2 text-bold'>Correo electrónico: contacto@operadoraprocea.com</p>
										<p className='padding-0 margin-2 text-bold margin-155-L'>rosana.mollinedo@acresco.com</p>
									</Grid>
								</Grid>
								
								
							</Grid>
						</Grid>
					</div>
				</div>
			</div>
		);
	}
}

CreditoProcea.propTypes = {};

export default IntegrationNotistack(CreditoProcea);
